import { render } from "./FooterBar.vue?vue&type=template&id=1198e20c&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=1198e20c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1621785964/src/bitbucket.org/hotelkey/hotelkeyapp.com-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1198e20c"]])

export default __exports__